const errorTree: Record<string, string> = {
    'Missing session_id or code.': 'Não foi enviado o ID da sessão',
    'Invalid or expired session.': 'Código expirado. Solicite um novo código.',
    'Invalid code.': 'Código inválido.',
    'Please wait a few minutes before requesting again.': 'Por favor espere alguns minutos antes de solicitar o código novamente.',
    "Telephone already exists.": "Telefone empresarial já em uso.",
    "Scout Telephone already exists.": "Já existe um scout registrado com esse número de telefone.",
    "Expired session.": "Sessão expirada. Refaça o processo.",
    "Multiple Invalid codes. Invalidating.": 'Muitas tentativas inválidas. Solicite o código novamente.',
    "No account created.": "Usuário não cadastrado.",
    "Telephone is required in session data.": "Sessão sem telefone.",
    "Maximum amount of licences reached.": "Número máximo de licenças atingido.",
    "User limit reached for your current plan.": "Número máximo de licenças de gestor atingido.",
    "Failed to fetch": "Tente novamente em alguns instantes, se o erro persistir, entre em contato com nosso time de suporte.",
    "unknown error": "Tente novamente em alguns instantes, se o erro persistir, entre em contato com nosso time de suporte.",
}

const extractErrorMessage = (value: unknown): string => {
    if (!value) {
        return 'unknown error'
    }

    if (typeof value === 'string') {
        return value
    }

    if (Array.isArray(value)) {
        return extractErrorMessage(value[0])
    }

    if (typeof value === 'object') {
        const record = value as Record<string, unknown>

        for (const key of ['error', 'detail', 'non_field_errors', 'message', 'telephone', 'username']) {
            if (key in record) {
                const nestedMessage = extractErrorMessage(record[key])
                if (nestedMessage) {
                    return nestedMessage
                }
            }
        }

        const firstValue = Object.values(record)[0]
        return extractErrorMessage(firstValue)
    }

    return String(value)
}

const normalizeErrorMessage = (message: string) => {
    if (message.includes('Duplicate entry') && message.includes('username')) {
        return 'Scout Telephone already exists.'
    }

    return message
}

const manageErrors = (response: Record<string, unknown>) => {
    const message = normalizeErrorMessage(extractErrorMessage(response))
    return errorTree[message] ?? message ?? 'Erro não mapeado.'
}

export default manageErrors
